"use client";

import { ActivityDisplayPreview } from "./previews";

type HIITDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function HIITDisplay({ data, participants }: HIITDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="hiit"
      data={data}
      participants={participants}
    />
  );
}
